import React from 'react';
import PropTypes from 'prop-types';
import { Button, CopyButton, DotsVertical, Edit01, Menu, Table, Trash01 } from '@opendate-app/setlist';

const GeneralAdmissionHoldsTable = ({ holds, onEdit, onDelete }) => {
  const columns = [
    { key: 'name', header: 'Name', primary: true, render: hold => hold.name || '--' },
    {
      key: 'ticket_types',
      header: 'Holding',
      render: hold => (hold.general_admission_hold_items || [])
        .map(item => `${item.quantity} × ${item.holdable?.name || '--'}${item.available_quantity == null ? '' : ` (${item.available_quantity} left)`}`)
        .join(', ') || '--'
    },
    {
      key: 'release_at',
      header: 'Release Date',
      render: hold => (hold.release_at ? new Date(hold.release_at).toLocaleString() : '--')
    },
    {
      key: 'total_held_count',
      header: 'Inventory Held',
      render: hold => (hold.total_held_count > 0 ? `${hold.total_held_count} (${hold.sold_count || 0} sold)` : 0)
    },
    {
      key: 'private_hold_url',
      header: 'Private Link',
      render: hold => (hold.private_hold_url ? (
        <div className="d-flex align-items-center" style={{ gap: 8 }}>
          <a href={hold.private_hold_url} target="_blank" className="text-truncate" style={{ maxWidth: '360px' }}>
            {hold.private_hold_url}
          </a>
          <CopyButton value={hold.private_hold_url} label={null} aria-label="Copy link" variant="tertiary" size="sm" />
        </div>
      ) : '')
    },
    {
      key: 'actions',
      header: '',
      align: 'right',
      render: hold => (
        <Menu
          placement="bottom-end"
          trigger={<Button variant="tertiary" size="sm" icon={DotsVertical} aria-label="Actions" />}
          items={[
            { icon: Edit01, label: 'Edit hold', onClick: () => onEdit(hold) },
            { icon: Trash01, label: 'Remove hold', destructive: true, onClick: () => onDelete(hold) }
          ]}
        />
      )
    }
  ];

  return (
    <div className="mb-3">
      <Table columns={columns} data={holds} getRowKey={hold => hold.id} empty="No holds yet." />
    </div>
  );
};

GeneralAdmissionHoldsTable.propTypes = {
  holds: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default GeneralAdmissionHoldsTable;
